import { AxiosResponse } from 'axios';
import { useCallback } from 'react';

import api from '@/utils/api';
import { getSigV4HeadersForGet } from '@/utils/cognito';
import { ApiUrl } from '@/utils/constants';
import { InstallationAddressInfoResponse } from '@/types/api/mypage/installationAddressInfo';

/** 設置先住所取得APIのURL */
const url = ApiUrl.Read.INSTALLATION_ADDRESS_INFO;

/**
 * 設置先住所取得APIの呼び出しフック。
 * 契約中サービスの設置先住所を表示するための情報を取得する。
 *
 * @returns execute - API実行関数
 */
const useGetInstallationAddressInfo = () => {
  const execute = useCallback(async (): Promise<AxiosResponse<InstallationAddressInfoResponse>> => {
    const headers = await getSigV4HeadersForGet(url);
    return api.get(url, headers);
  }, []);

  return { execute };
};

export default useGetInstallationAddressInfo;
